import React from "react";

const AngkutanLebaran = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Lebaran 2022"
        src="https://lookerstudio.google.com/embed/reporting/3bdd4a22-7dd3-42df-8f80-faa4d2ee39c8/page/XYjqC"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
      <iframe
        title="Data Lebaran 2023"
        src="https://lookerstudio.google.com/embed/reporting/aa07d042-03de-4963-af9b-98040f583ca8/page/XYjqC"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
      <iframe
        title="Data Lebaran 2024"
        src="https://lookerstudio.google.com/embed/reporting/82dd2c49-fe7b-411e-a71b-16b7e65d80f3/page/p_bf557rteuc"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default AngkutanLebaran;
